import React from 'react';

function ImagePreview(props) {
  const { url, className, ...restProps } = props;
  return <img alt={`Preview for ${url}`} src={url} className={className} {...restProps} />;
}

export default ImagePreview;
